import React from 'react';
import { tileData } from '../../shared/shared.constants';
import { TileComponent } from '../../shared/components/tileLink';
import { Grid2 as Grid } from '@mui/material';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';

export const TileGridGroup = () => {
  const { routeData } = useAppSelector(metaDataSelector);
  return (
    <Grid container spacing={2}>
      {tileData.map((item) => (
        <TileComponent
          key={item.tileText}
          imgSrc={item.imgSrc}
          imgSrcOnHover={item.imgSrcOnHover}
          altVal={item.altVal}
          tileText={item.tileText}
          toLink={
            routeData.fillMandatoryFields && item.dynamicRoute
              ? item.dynamicRouteLink
              : item.toLink
          }
        />
      ))}
    </Grid>
  );
};
